import * as Business                   from '../business';
import { connect }                     from 'react-redux';
import { initializePushNotifications } from '../push';
import { useEffect }                   from 'react';


export default connect(
  (state, { businessID }) => ({
    needsOnboarding: Business.needsOnboarding(state, businessID)
  }),
)(CheckOnboarding);


export function CheckOnboarding({ children, businessID, path, needsOnboarding, navigateTo }) {
  const urlWithoutBusiness = !businessID;

  // Eventually /welcome will have child routes. We don't want to redirect
  // those, so we use path.includes.
  const onboardingPath = `/${businessID}/welcome`;
  const needsRedirect  = needsOnboarding && !path.includes(onboardingPath);

  // We don't want to initialize notifications until we're sure needsOnboarding is false.
  // (It will be undefined until the business is loaded.)
  const shouldInitializeNotifications = urlWithoutBusiness || needsOnboarding === false;

  useEffect(function() {
    if (needsRedirect)
      navigateTo(onboardingPath, { reloadCurrent: true });
  }, [ needsRedirect, navigateTo, onboardingPath ]);

  useEffect(function() {
    if (shouldInitializeNotifications)
      initializePushNotifications();
  }, [ shouldInitializeNotifications ]);

  return children;
}
